import React from 'react';

interface Feature {
  icon: React.ReactNode;
  label: string;
  color?: string;
}

interface FeaturesGridProps {
  features: readonly Feature[];
  variant?: 'light' | 'dark';
  borderColor?: string;
  textColor?: string;
}

export const FeaturesGrid: React.FC<FeaturesGridProps> = ({
  features,
  variant = 'dark',
  borderColor,
  textColor
}) => {
  const getBorderClass = () => {
    if (borderColor) return borderColor;
    return variant === 'dark' ? 'border-white/20' : 'border-gray-200';
  };

  const getTextClass = () => {
    if (textColor) return textColor;
    return variant === 'dark' ? 'text-white/90' : 'text-gray-700';
  };

  if (!features || features.length === 0) return null;

  return (
    <div className={`grid grid-cols-3 gap-4 pt-4 border-t ${getBorderClass()}`}>
      {features.map((feature, index) => (
        <div key={index} className="flex flex-col items-center text-center">
          <div className="flex items-center justify-center mb-2">
            {feature.icon}
          </div>
          <div className={`text-sm font-medium ${getTextClass()}`}>
            {feature.label}
          </div>
        </div>
      ))}
    </div>
  );
};